import { render, staticRenderFns } from "./LEDConverter.vue?vue&type=template&id=8dc8012e&scoped=true&"
import script from "./LEDConverter.vue?vue&type=script&lang=js&"
export * from "./LEDConverter.vue?vue&type=script&lang=js&"
import style0 from "./LEDConverter.vue?vue&type=style&index=0&id=8dc8012e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc8012e",
  null
  
)

export default component.exports